// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsThemesForm_heading__JanuA","form":"ReportingDetailsThemesForm_form__wc6DW"};